import React, { useCallback, useEffect, useState } from 'react';

import './detailView.scss';
import Category from '../../components/category/Category';
import { MonTextS16W300LH26, MonTextS75W700 } from '../../components/texts/fontText/montserrat/TextMon';
import DateText from '../../components/texts/dateText/DateText';
import { PodTextS30W500Lh400 } from '../../components/texts/fontText/podkova/TextPodkova';
import MiniSubscribeBtn from '../../components/buttons/subscribe/miniSub/MiniSubscribeBtn';
import BackToListBtn from '../../components/buttons/backToList/BackToListBtn';
import { useNavigate, useParams } from 'react-router-dom';
import { axiosAuth } from '../../api/api';
import UpdatesTodayNews from '../../components/detail/UpdatesTodayNews';
import { useQuery } from '@tanstack/react-query';
import { INewsItem } from '../../tpyes/comment';

const DetailView = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [responsive, setResponsive] = useState('');

  if (!params.id || !Number(params.id)) {
    navigate(-1);
  }

  const [newsData, setNewsData] = useState<INewsItem>();
  const [detailLoading, setDetailLoading] = useState(true);

  // 뉴스 데이터
  const getDetailPage = useCallback(async (pageNumber: number) => {
    const response = await axiosAuth.get(`/news/api/news/${+pageNumber}/`);
    if (response.status === 200) {
      setNewsData(response.data);
      setDetailLoading(false);
    }
  }, []);

  const { data: TodayNews, isSuccess } = useQuery({
    queryKey: ['updateTodayNews'],
    queryFn: async () => {
      const response = await axiosAuth.get('/news/api/news?limit=4');
      return response.data;
    },
  });

  useEffect(() => {
    getDetailPage(Number(params.id));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [params]);

  const handleResize = () => {
    if (1300 < window.innerWidth) {
      setResponsive('desktop');
    } else if (768 < window.innerWidth && window.innerWidth <= 1300) {
      setResponsive('tablet');
    } else {
      setResponsive('mobile');
    }
  };

  useEffect(() => {
    if (1300 < window.innerWidth) {
      setResponsive('desktop');
    } else if (768 < window.innerWidth && window.innerWidth <= 1300) {
      setResponsive('tablet');
    } else {
      setResponsive('mobile');
    }
    window.addEventListener('resize', handleResize);
    return () => {
      // cleanup
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="detailView">
      <div className="arrow_container">
        <div className="arrow_box flex ai-center jc-center cursor-pointer">
          <img
            onClick={() => {
              navigate(-1);
            }}
            src="/seamansclub-news/assets/svg/arrow-left.svg"
            alt=""
            className=""
          />
        </div>
      </div>

      <div className="content-container">
        <div className={`box ${responsive === 'desktop' ? 'flex' : ''}`}>
          <div className="left_layout">
            <Category value={newsData?.category?.name} />
            <MonTextS75W700 text={newsData?.title} />
            <MonTextS16W300LH26 text={newsData?.subtitle} />
            <DateText date={newsData?.created_at ? newsData.created_at : undefined} />
            <div className="main-box">
              <span className='content' dangerouslySetInnerHTML={{ __html: newsData?.content || '' }}></span>
            </div>
            <div
              className="source cursor-pointer"
              onClick={() => {
                location.href = newsData?.sources[0]?.url ? newsData.sources[0].url : '/';
              }}
            >
              Soruce : {!detailLoading && newsData?.sources[0]?.url ? newsData.sources[0].url : '/'}
            </div>
            <div className="backTo-container flex jc-center">
              <BackToListBtn />
            </div>
          </div>
          <div className="spacing"></div>
          <div className="right_layout">
            <div className="news_box">
              <div className="flex flex jc-center">
                <PodTextS30W500Lh400 text={'Updates Today News'} />
              </div>

              <div className="content_box">
                <div className="flex jc-between">
                  <div className="text-box">
                    {isSuccess && TodayNews
                      ? TodayNews.results.map((item: INewsItem) => {
                          return (
                            <UpdatesTodayNews
                              id={+item.id!}
                              key={item.id}
                              category={item?.category?.name ? item.category.name : ''}
                              title={item.title!}
                              image={item.image!}
                              created_at={item?.created_at ? item?.created_at : ''}
                            />
                          );
                        })
                      : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="adver_box">
              {/* <div>
                <div className="flex flex jc-center ai-center">
                  <PodTextS30W500Lh400 text={'advertisement'} />
                </div>
                <div className="advertisement">
                  <img src="" alt="" height={162} width={520} />
                  <img src="" alt="" height={162} width={520} className="adv_img" />
                  <img src="" alt="" height={162} width={520} />
                </div>
              </div> */}
            </div>
            <div className="subscribe_box ">
              <MiniSubscribeBtn />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailView;
